
import './AvatarItem.scss';
export default function AvatarItem(props: any) {
    return (
        <div className="profile" style={{
            width: '100%',
            height: '100%'
        }}>
            <div onClick={() => {
                if (props.onClick) {
                    props.onClick();
                }
            }} className="gv2-asset" tabIndex="-1" style={{ "width": "100%", "display": "inline-block" }}>
                <a className="sc-bZQynM jkjeQM basic-card " data-testid="PENNY PROUD" tabIndex={0} data-gv2elementkey="contentTile" data-gv2elementvalue="2b820727-1019-5291-9476-497aa1a91adc">
                    <div className="sc-bdVaJa hRKcBi image-container" alt="PENNY PROUD" aria-label="PENNY PROUD" style={{ "background": "none", "borderRadius": "4px", "paddingTop": "100%" }}>
                        <div>
                            <img alt="PENNY PROUD" src={props.imgSrc || "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/6D01CF924A47BE0FD81E9087A3C7D909AF61E1206D87198F6241C1BF455B4DFB/scale?width=300&amp;aspectRatio=1.00&amp;format=png"} className="sc-bwzfXH kQAqDF" />
                            <img alt="PENNY PROUD" className="sc-bwzfXH kQAqDF hover-image"
                                src={props.imgSrc ||
                                    "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/6D01CF924A47BE0FD81E9087A3C7D909AF61E1206D87198F6241C1BF455B4DFB/scale?width=300&amp;aspectRatio=1.00&amp;format=png"} />
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
}